var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.98079 12.6627L8.33434 13.0148L8.68721 12.662L13.8241 7.52511L14.2945 7.99883L8.33366 13.9596L5.70743 11.3334L6.17601 10.8648L7.98079 12.6627ZM2.16699 10.5001C2.16699 6.17622 5.67647 2.66675 10.0003 2.66675C14.3242 2.66675 17.8337 6.17622 17.8337 10.5001C17.8337 14.8239 14.3242 18.3334 10.0003 18.3334C5.67647 18.3334 2.16699 14.8239 2.16699 10.5001ZM2.83366 10.5001C2.83366 14.4512 6.04918 17.6667 10.0003 17.6667C13.9515 17.6667 17.167 14.4512 17.167 10.5001C17.167 6.54894 13.9515 3.33341 10.0003 3.33341C6.04918 3.33341 2.83366 6.54894 2.83366 10.5001Z",
    stroke: "#00BC4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.37cd091806f848fbc98af861317ddea9.svg";
export { ForwardRef as ReactComponent };